<div
  #treeListContainerEl
  class="tree-list-container"
  [appBlockModalDrag]="!(isMobileModeObservable | async)"
>
  <app-tree-list
    class="tree-list"
    [items]="treeList"
    [openedIndicatorEnabled]="false"
  >
  </app-tree-list>

  <ng-template
    #treeItemTpl
    let-item="item"
    let-items="items"
    let-index="index"
    let-level="level"
  >
    <div
      class="item-template-wrapper"
      [ngClass]="{
        opened: !!item.opened,
        'first-child': index === 0,
        'last-child': !!(items.length - 1 === index),
        'first-level': level === 1
      }"
    >
      <div class="text">
        <ng-template
          [ngTemplateOutlet]="itemValueTpl"
          [ngTemplateOutletContext]="{
            field: item.displayField,
            value: item.displayFieldValue ?? item.text,
            layer: item.layer
          }"
        ></ng-template>
      </div>
    </div>
  </ng-template>

  <ng-template #treePropertiesTpl let-item="item" let-level="level">
    <div
      #objectInfoContainerEl
      class="object-info-container"
      style="--tree-item-level: {{ level }}"
      [ngClass]="{ selected: !!item.selected }"
    >
      <app-list
        class="property-list"
        [items]="item.propertiesObservable | async"
        [scrollable]="false"
        keyExpr="label"
        (click)="onGraphicItemSelected(item)"
      >
        <ng-template listItem let-item="item">
          <div class="property-item">
            {{ item.label }}:
            <ng-template
              [ngTemplateOutlet]="
                isFieldUrl(item.field) ? itemValueUrlTpl : itemValueTpl
              "
              [ngTemplateOutletContext]="item"
            ></ng-template>
          </div>
        </ng-template>
      </app-list>

      <div
        class="attachment-list"
        *ngIf="!!(item.canShowAttachmentsObservable | async)"
      >
        <app-attachments
          [layer]="item.layer"
          [objectId]="item.objectId"
        ></app-attachments>
      </div>

      <div
        class="relationships-list"
        *ngIf="!!(item.canShowRelationshipListObservable | async)"
      >
        <div class="title">Registos Relacionados</div>

        <app-tree-list
          class="tree-list"
          [items]="item.relationshipListObservable | async"
          [openedIndicatorEnabled]="false"
        >
        </app-tree-list>
      </div>

      <app-loading-panel
        *ngIf="!!item.loadingController"
        [visible]="item.loadingController.changes | async"
        [container]="objectInfoContainerEl"
        [overlayMask]="false"
      ></app-loading-panel>
    </div>
  </ng-template>

  <ng-template #itemValueUrlTpl let-field="field" let-value="value">
    <a
      *ngIf="!!value"
      class="link"
      [href]="value"
      target="_blank"
      (click)="$event.stopPropagation()"
    >
      {{ accessHereText }}
    </a>
  </ng-template>

  <ng-template
    #itemValueTpl
    let-field="field"
    let-value="value"
    let-layer="layer"
  >
    {{ value | fieldFormat : field : layer }}
  </ng-template>
</div>

<div class="actions-bottom">
  <div class="btn-item" [appBlockModalDrag]="!(isMobileModeObservable | async)">
    <app-button
      buttonType="primary"
      styleType="contained"
      sizeType="small"
      text="{{ bufferText }}"
      [disabled]="isBtnBufferDisabled"
      (click)="onBtnBufferClick()"
    ></app-button>
  </div>

  <div class="btn-item" [appBlockModalDrag]="!(isMobileModeObservable | async)">
    <app-button
      buttonType="primary"
      styleType="contained"
      sizeType="small"
      text="{{ symbologyText }}"
      (click)="onBtnHighlightConfigClick()"
    ></app-button>
  </div>

  <div
    class="btn-item"
    [appBlockModalDrag]="!(isMobileModeObservable | async)"
    *ngIf="isBtnExportXlsxVisible"
  >
    <app-button
      buttonType="primary"
      styleType="contained"
      sizeType="small"
      text=".XLSX"
      [disabled]="isBtnExportDisabled"
      (click)="onBtnExportXlsxClick()"
    ></app-button>
  </div>

  <div
    class="btn-item"
    [appBlockModalDrag]="!(isMobileModeObservable | async)"
    *ngIf="isBtnExportKmlVisible"
  >
    <app-button
      buttonType="primary"
      styleType="contained"
      sizeType="small"
      text=".KML"
      [disabled]="isBtnExportDisabled"
      (click)="onBtnExportKmlClick()"
    ></app-button>
  </div>

  <div
    class="btn-item"
    [appBlockModalDrag]="!(isMobileModeObservable | async)"
    *ngIf="isBtnExportShpVisible"
  >
    <app-button
      buttonType="primary"
      styleType="contained"
      sizeType="small"
      text=".SHP"
      [disabled]="isBtnExportDisabled"
      (click)="onBtnExportShpClick()"
    ></app-button>
  </div>

  <div class="btn-item" [appBlockModalDrag]="!(isMobileModeObservable | async)">
    <app-button
      buttonType="primary"
      styleType="contained"
      sizeType="small"
      text="{{ zoomText }}"
      (click)="onBtnZoomToClick()"
      [disabled]="!hasGraphicsSelected"
    ></app-button>
  </div>

  <div class="btn-item" [appBlockModalDrag]="!(isMobileModeObservable | async)">
    <app-button
      buttonType="primary"
      styleType="contained"
      sizeType="small"
      text="{{ !allGraphicsSelected ? selectAllText : clearSelectionText }}"
      (click)="onBtnToggleSelectAllClick()"
      [disabled]="!hasGraphicResults"
    ></app-button>
  </div>

  <div class="btn-item" [appBlockModalDrag]="!(isMobileModeObservable | async)">
    <app-button
      buttonType="primary"
      styleType="contained"
      sizeType="small"
      text="{{ clearText }}"
      (click)="onBtnClearClick()"
    ></app-button>
  </div>
</div>

<app-loading-panel
  [visible]="loadingController.changes | async"
  [container]="treeListContainerEl"
  [overlayMask]="false"
></app-loading-panel>

<app-buffer-form
  [(visible)]="bufferFormModalVisible"
  [(value)]="bufferConfigGroup"
  (valueChange)="onBufferConfigChanged()"
></app-buffer-form>

<app-highlight-config-form
  [(visible)]="highlightConfigModalVisible"
  [(value)]="highlightConfigGroup"
  (valueChange)="onHighlightConfigChanged()"
></app-highlight-config-form>
